import { useState } from "react";
import { useAuth } from "../AuthContext";
import { supabase } from "../supabase";
import { T } from "../utils";

export default function Login() {
  const { signIn, authError } = useAuth();
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [success,  setSuccess]  = useState("");
  const [loading,  setLoading]  = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    setError("");
    const err = await signIn(email, password);
    if (err) setError(err.message || "Invalid email or password");
    setLoading(false);
  };

  return (
    <div style={{ minHeight:"100vh", background:`linear-gradient(135deg, ${T.navy} 0%, ${T.navyLight} 100%)`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&display=swap" rel="stylesheet"/>

      <div style={{ width:420, background:T.white, borderRadius:16, padding:"40px 36px", boxShadow:"0 24px 64px rgba(0,0,0,0.25)" }}>
        {/* Logo */}
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <img src="/logo192.png" alt="CCN" style={{ width:72, height:72, objectFit:"contain", marginBottom:8 }}/>
          <div style={{ fontFamily:"'Playfair Display',serif", fontSize:20, fontWeight:700, color:T.navy }}>Clarion Call Network</div>
          <div style={{ fontFamily:"'Playfair Display',serif", fontSize:13, fontWeight:600, color:T.orange, marginTop:2 }}>Raising Kings and Priests</div>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom:16 }}>
            <div style={{ fontSize:12, fontWeight:600, color:T.grey600, marginBottom:6 }}>EMAIL ADDRESS</div>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              style={{ width:"100%", boxSizing:"border-box", padding:"11px 14px", borderRadius:8, border:`1.5px solid ${T.grey200}`, fontSize:14, fontFamily:"'DM Sans',sans-serif", color:T.grey800, outline:"none", background:T.grey50 }}
            />
          </div>

          <div style={{ marginBottom:24 }}>
            <div style={{ fontSize:12, fontWeight:600, color:T.grey600, marginBottom:6 }}>PASSWORD</div>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={{ width:"100%", boxSizing:"border-box", padding:"11px 14px", borderRadius:8, border:`1.5px solid ${T.grey200}`, fontSize:14, fontFamily:"'DM Sans',sans-serif", color:T.grey800, outline:"none", background:T.grey50 }}
            />
          </div>

          {(error || authError) && (
            <div style={{ padding:"10px 14px", background:T.redBg, border:`1px solid ${T.red}`, borderRadius:8, fontSize:13, color:T.red, marginBottom:16 }}>
              ⚠️ {error || authError}
            </div>
          )}
          {success && (
            <div style={{ padding:"10px 14px", background:T.greenBg, border:`1px solid ${T.green}`, borderRadius:8, fontSize:13, color:T.green, marginBottom:16 }}>
              ✓ {success}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{ width:"100%", padding:"12px", borderRadius:8, border:"none", background:T.navy, color:"#fff", fontSize:15, fontWeight:700, cursor:loading?"not-allowed":"pointer", opacity:loading?0.7:1, fontFamily:"'DM Sans',sans-serif" }}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        {/* Divider */}
        <div style={{ display:"flex", alignItems:"center", gap:12, margin:"20px 0" }}>
          <div style={{ flex:1, height:1, background:T.grey200 }}/>
          <div style={{ fontSize:11, color:T.grey400 }}>or</div>
          <div style={{ flex:1, height:1, background:T.grey200 }}/>
        </div>

        {/* Google Sign-In */}
        <button
          onClick={async () => {
            setLoading(true); setError("");
            const { error:e } = await supabase.auth.signInWithOAuth({
              provider: 'google',
              options: { redirectTo: window.location.origin }
            });
            if (e) { setError(e.message); setLoading(false); }
          }}
          disabled={loading}
          style={{ width:"100%", padding:"11px", borderRadius:8, border:`1.5px solid ${T.grey200}`, background:T.white, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:10, fontSize:14, fontWeight:600, color:T.grey800, fontFamily:"'DM Sans',sans-serif" }}>
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          Sign in with Google
        </button>

        {/* New people sign up themselves; HQ then approves them */}
        <div style={{ marginTop:16, textAlign:"center", fontSize:13, color:T.grey600 }}>
          New here? <a href="/register" style={{ color:T.navy, fontWeight:700 }}>Sign up</a>
        </div>

        <div style={{ marginTop:16, textAlign:"center", fontSize:12, color:T.grey400 }}>
          Forgot your password?{" "}
          <button onClick={async () => {
            if (!email) { setError("Enter your email address above first."); return; }
            setLoading(true);
            const { error: e } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin });
            setLoading(false);
            if (e) setError(e.message);
            else setSuccess("Password reset email sent! Check your inbox.");
          }}
            style={{ background:"none", border:"none", color:T.orange, fontWeight:600, cursor:"pointer", fontSize:12, padding:0 }}>
            Reset via email
          </button>
        </div>

        <div style={{ marginTop:28, padding:"14px 16px", background:T.goldPale, borderRadius:10, fontSize:12, color:T.amber, textAlign:"center", lineHeight:1.7 }}>
          <strong>Clarion Call Network</strong><br/>
          2nd floor, Allgate House, Nkrumah Lane<br/>
          Next to KPLC Electricity House, Nairobi CBD<br/>
          0707 977 829
        </div>
      </div>
    </div>
  );
}
